import { useState, useEffect, useCallback } from "react";
import { getPaymentLedgerList } from "PlatForms/SelfLMS/Services/PaymentLedger/PaymentLedgerService";
import { toast } from "react-toastify";

export const usePaymentLedger = () => {
  const [payments, setPayments] = useState({
    items: [],
    totalCount: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1
  });
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    pageNumber: 1,
    pageSize: 10,
    orderByLatest: true,
    search: "",
    startDate: null,
    endDate: null,
    status: null,
    sourceType: null
  });

  const loadPayments = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getPaymentLedgerList(filters);
      console.log(".???????????????????????? ledger lsit", data);
      setPayments(data);
    } catch (error) {
      console.error("Error loading payment ledger:", error);
      toast.error("Failed to load payment ledger data");
      setPayments({
        items: [],
        totalCount: 0,
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1
      });
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    loadPayments();
  }, [loadPayments]);

  const handlePageChange = (pageNumber, pageSize) => {
    setFilters(prev => ({
      ...prev,
      pageNumber,
      pageSize
    }));
  };

  const handleFilterChange = (newFilters) => {
    setFilters(prev => ({
      ...prev,
      ...newFilters,
      pageNumber: 1
    }));
  };

  const handleResetFilters = () => {
    setFilters({
      pageNumber: 1,
      pageSize: 10,
      orderByLatest: true,
      search: "",
      startDate: null,
      endDate: null,
      status: null,
      sourceType: null
    });
  };

  return {
    payments,
    loading,
    filters,
    handlePageChange,
    handleFilterChange,
    handleResetFilters,
    refresh: loadPayments
  };
};